import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { selectProducts } from '../../features/productSlice';
import CardList from '../Cards/CardList';
import SearchBox from './SearchBox/SearchBox';
import Navigation from '../Navigation/navigation';
import Footer from '../Footer/Footer';
import PandaBuySignUpLink from '../PandaBuySignUpLink/PandaBuySignUpLink';
import { Helmet } from 'react-helmet';
import { useLocation } from 'react-router-dom';

const Products = () => {
  const location = useLocation();
  const productsState = useSelector(selectProducts);
  const [search, setSearch] = useState('');
  const [selectedCategory, setSelectedCategory] = useState('All');
  const [filteredProducts, setFilteredProducts] = useState([]);

  const categories = [
    "All",
    "Shoes",
    "Hoodies/Sweaters",
    "T-Shirts",
    "Jackets",
    "Pants/Shorts",
    "Headwear",
    "Accessories",
    "Other Stuff"
  ];

  // On mount or location change, check for category passed via navigation state
  useEffect(() => {
    if (location.state?.category) {
      setSelectedCategory(location.state.category);
      // Clear location state so category does not persist across other navigations
      window.history.replaceState({}, document.title);
    }
  }, [location.state]);

  // Apply filters whenever products, search or category changes
  useEffect(() => {
    applyFilters();
  }, [productsState.products, search, selectedCategory]);

  // Scroll to top on category change
useEffect(() => {
  window.scrollTo({ top: 0, behavior: 'smooth' });
}, [selectedCategory]);

  const applyFilters = () => {
    let filtered = [...productsState.products];

    if (search.trim() !== '') {
      filtered = filtered.filter(product => {
        const productSearchName = product.searchName.toLowerCase().replace(/\+/g, ' ');
        const searchTerm = search.toLowerCase().trim();
        return productSearchName.includes(searchTerm);
      });
    }

    if (selectedCategory !== 'All') {
      filtered = filtered.filter(product => product.category === selectedCategory);
    }

    setFilteredProducts(filtered);
  };

  const handleSearchSubmit = (searchTerm) => {
    setSearch(searchTerm);
    setSelectedCategory('All');
    window.scrollTo({ top: 0, behavior: 'instant' }); // 🔁 Force before filter
  };



  return (
    <>
      <Helmet>
        <title>Superbuy Spreadsheet containing 7000+ finds</title>
        <meta
          name="description"
          content="collection of over 7000+ superbuy finds on our web-based spreadsheet."
        />
        <meta name="robots" content="index, follow" />
        <link rel="canonical" href="https://www.superbuyspreadsheet.net/products" />
        <link rel="sitemap" type="application/xml" title="Sitemap" href="https://www.superbuyspreadsheet.net/sitemap.xml" />
        <script type="application/ld+json" src="/schema.org.json"></script>
      </Helmet>

      <PandaBuySignUpLink />
      <Navigation
        selectedCategory={selectedCategory}
        setSelectedCategory={setSelectedCategory}
      />

      <h1 className="text-xl text-gray-800 mb-2 font-bold text-center p-6 mx-auto max-w-3xl">
        Browse Superbuy products
      </h1>

      <SearchBox onSearchSubmit={handleSearchSubmit} />

      <CardList products={filteredProducts} search={search} selectedCategory={selectedCategory} />

      <Footer />
    </>
  );
};

export default Products;
